// import React, { useEffect, useState } from "react";
// import DateRange from "../DateRange/DateRange";
// import { dashboardIcon } from "../../assets/img";
// import { URLS } from "../../Services/Constant";
// import { useGlobalContext } from "../../Services/PaginationGlobal";
// import { useLocation } from "react-router-dom";
// import { get } from "../../Services/ApiHandler";

// export const RevenueCard = () => {
//   const styles = {
//     label: {
//       /* Title */

//       fontFamily: "Open Sans",
//       fontStyle: "normal",
//       fontWeight: "600",
//       fontSize: "16px",
//       lineHeight: "22px",
//       /* identical to box height */
//       // display: flex;
//       // align-items: center;

//       color: "#A7A7A7",
//     },
//     value: {
//       /* Title */

//       fontFamily: "Open Sans",
//       fontStyle: "normal",
//       fontWeight: "600",
//       fontSize: "18px",
//       lineHeight: "25px",
//       /* identical to box height */
//       // display: flex;
//       // align-items: center;

//       color: "#222227",
//     },
//   };
//   const [isData, setIsData] = useState([]);
//   // const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
//   const { paginationData, setpaginationData } = useGlobalContext();
//   const { pathname, state } = useLocation();
//   const path = pathname?.replace("/", "");
//   const [selectedFilter, setSelectedFilter] = useState(
//     paginationData?.[path]
//       ? { ...paginationData?.[path] }
//       : {
//           from: "",
//           to: "",
//         }
//   );
//   const getTopCard = async () => {
//     // Start with base URL
//     let url = URLS.DASHBOARREVENUE_CARD;

//     // Build query parameters array
//     const params = [];
//     if (selectedFilter.from && selectedFilter.to) {
//       params.push(`from_date=${selectedFilter.from}`);
//       params.push(`to_date=${selectedFilter.to}`);
//     }

//     // Add params to URL if they exist
//     console.log("params", params);

//     if (params.length > 0) {
//       url += `?${params.join("&")}`;
//     }

//     let res = await get(url);
//     console.log("roles res", res);
//     if (res?.status === "success") {
//       setIsData(res?.data ?? []);
//     }
//   };

//   useEffect(() => {
//     getTopCard(); // Only from_date will be sent
//   }, [selectedFilter.from && selectedFilter.to]);

//   const handleChangeFilter = (name, val) => {
//     setSelectedFilter((prev) => ({ ...prev, [name]: val }));
//   };
//   console.log("RevenueCardisData", isData);

//   return (
//     <>
//       <div
//         style={{
//           padding: 20 /* Rectangle 19061 */,
//           width: "100%",
//           background: "#FFFFFF",
//           boxShadow: "0px 1px 10.4px rgba(0, 0, 0, 0.1)",
//           borderRadius: "10px",
//           height: "100%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "space-between",
//             alignItems: "center",
//             gap: 20,
//           }}
//         >
//           <p
//             style={{
//               //
//               fontStyle: "normal",
//               fontWeight: "700",
//               fontSize: "17px",
//               lineHeight: "23px",
//               display: "flex",
//               alignItems: "center",
//               width: "80px",
//               color: "#222227",
//             }}
//           >
//             Revenue
//           </p>
//           <div style={{ width: "80%" }}>
//             <DateRange
//               setFromDate={(date) => {
//                 handleChangeFilter("from", date);
//               }}
//               setToDate={(date) => {
//                 handleChangeFilter("to", date);
//               }}
//             />
//           </div>
//         </div>
//         <div
//           style={{
//             border: "1px solid #EEEEEE",
//             display: "flex",
//             justifyContent: "space-between",
//             borderRadius: "20px",
//             padding: "20px 30px",
//             marginTop: "20px",
//           }}
//         >
//           <div>
//             <p
//               style={{
//                 fontSize: "18px",
//                 fontWeight: "400",
//                 color: "#9ca3af",
//                 margin: 0,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//               }}
//             >
//               Overall Revenue
//             </p>
//             <p
//               style={{
//                 fontSize: "26px",
//                 fontWeight: "bold",
//                 color: "#000000",
//                 margin: 0,
//               }}
//             >
//               {isData?.overall_revenue}
//             </p>
//           </div>
//           <div style={{ width: "30px", height: "30px" }}>
//             <img
//               src={dashboardIcon}
//               className="iconContainer"
//               alt=""
//               style={{ width: "100%", height: "100%" }}
//             />{" "}
//           </div>
//         </div>
//         <div>
//           <p
//             style={{
//               marginTop: "10px" /* Total */,

//               fontFamily: "Open Sans",
//               fontStyle: "normal",
//               fontWeight: "700",
//               fontSize: "17px",
//               lineHeight: "23px",

//               color: "#222227",
//             }}
//           >
//             Total
//           </p>
//           <div
//             style={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: 4,
//               justifyContent: "space-between",
//               marginTop: "10px",
//             }}
//           >
//             <div
//               style={{
//                 background: "#F5F5F5",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//                 display: "flex",
//                 // width: "235",
//                 padding: "10px",
//                 width: "48%",
//                 borderRadius: "10px",
//                 marginBottom: "10px",
//               }}
//             >
//               <p style={styles.label}>Booking Revenue</p>
//               <p style={styles.value}>{isData?.booking_revenue || 0}</p>
//             </div>
//             <div
//               style={{
//                 background: "#F5F5F5",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//                 display: "flex",
//                 // width: "235",
//                 padding: "10px",
//                 width: "48%",
//                 borderRadius: "10px",
//                 marginBottom: "10px",
//               }}
//             >
//               <p style={styles.label}>MMC Revenue</p>
//               <p style={styles.value}>{isData?.mmc_revenue || 0}</p>
//             </div>
//             <div
//               style={{
//                 background: "#F5F5F5",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//                 display: "flex",
//                 // width: "235",
//                 padding: "10px",
//                 width: "48%",
//                 borderRadius: "10px",
//               }}
//             >
//               <p style={styles.label}>Tips Revenue</p>
//               <p style={styles.value}>{isData?.tips_revenue || 0}</p>
//             </div>
//             <div
//               style={{
//                 background: "#F5F5F5",
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//                 display: "flex",
//                 // width: "235",
//                 padding: "10px",
//                 width: "48%",
//                 borderRadius: "10px",
//               }}
//             >
//               <p style={styles.label}>Cancellation Revenue</p>
//               <p style={styles.value}>{isData?.cancellation_revenue || 0}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
import React, { useEffect, useState } from "react";
import DateRange from "../DateRange/DateRange";
import { dashboardIcon } from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";
import { get } from "../../Services/ApiHandler";

export const RevenueCard = () => {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  const [isData, setIsData] = useState({});
  const { paginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]
      ? { ...paginationData?.[path] }
      : { from: "", to: "" }
  );

  const getTopCard = async () => {
    let url = URLS.DASHBOARREVENUE_CARD;
    const params = [];

    if (selectedFilter.from && selectedFilter.to) {
      params.push(`from_date=${selectedFilter.from}`);
      params.push(`to_date=${selectedFilter.to}`);
    }

    if (params.length > 0) url += `?${params.join("&")}`;

    try {
      let res = await get(url);
      if (res?.status === "success") {
        setIsData(res?.data ?? {});
      }
    } catch (error) {
      console.error("Error fetching revenue data:", error);
    }
  };

  useEffect(() => {
    getTopCard();
  }, [selectedFilter.from, selectedFilter.to]);

  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  return (
    <div
      style={{
        padding: 14, // smaller
        width: "100%",
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", // slightly lighter
        borderRadius: "8px", // smaller
        height: "100%",
      }}
    >
      {/* Revenue + Date */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12, // smaller
        }}
      >
        <p
          style={{
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "15px", // smaller
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#222227",
            margin: 0,
          }}
        >
          Revenue
        </p>

        <div className="d-flex ac-jb mt-2 gap-1 flex-wrap">
          <DateRange
            setFromDate={(date) => handleChangeFilter("from", date)}
            setToDate={(date) => handleChangeFilter("to", date)}
          />
        </div>
      </div>

      {/* Overall Revenue */}
      <div
        style={{
          border: "1px solid #EEEEEE",
          display: "flex",
          justifyContent: "space-between",
          borderRadius: "16px", // smaller
          padding: "14px 20px", // smaller
          marginTop: "14px", // smaller
        }}
      >
        <div>
          <p
            style={{
              fontSize: "16px", // smaller
              fontWeight: "400",
              color: "#9ca3af",
              margin: 0,
            }}
          >
            Overall Revenue
          </p>
          <p
            style={{
              fontSize: "22px", // smaller
              fontWeight: "bold",
              color: "#000000",
              margin: 0,
            }}
          >
            {isData?.overall_revenue &&
              (isData?.overall_revenue || 0)?.toFixed(2)}
          </p>
        </div>

        <div style={{ width: "26px", height: "26px" }}>
          {" "}
          {/* smaller */}
          <img
            src={dashboardIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      {/* Total Section */}
      <p
        style={{
          marginTop: "8px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
        }}
      >
        Total
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          justifyContent: "space-between",
          marginTop: "8px",
        }}
      >
        {/* Each Row */}
        {[
          { label: "Booking Revenue", value: isData?.booking_revenue },
          { label: "MMC Revenue", value: isData?.mmc_revenue },
          { label: "Tips Revenue", value: isData?.tips_revenue },
          {
            label: "Cancellation Revenue",
            value: isData?.cancellation_revenue,
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: "#F5F5F5",
              flexDirection: "row",
              justifyContent: "space-between",
              display: "flex",
              padding: "8px 10px", // smaller
              width: "48%",
              borderRadius: "8px", // smaller
              marginBottom: "8px", // smaller
            }}
          >
            <p style={styles.label}>{item.label}</p>
            <p style={styles.value}>
              {item.value && (item.value || 0)?.toFixed(2)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
